import { notifications } from "@mantine/notifications"

import { queryClient } from "~/backend/queryClient"
import {
  findSupplierMappingQueryKey,
  useUpdateSupplierMapping,
} from "~/gen/api/hooks"
import { showAxiosError } from "~/utils/showAxiosError"

export const useUpdateSupplierMappingMutation = ({
  searchSupplier,
}: {
  searchSupplier: string
}) =>
  useUpdateSupplierMapping({
    mutation: {
      onSuccess: async () => {
        notifications.show({
          title: "Supplier updated",
          message: "Supplier updated successfully",
          color: "teal",
        })
        await queryClient.invalidateQueries(
          findSupplierMappingQueryKey({
            searchSupplier,
          })
        )
      },
      onError: (error: Error) => {
        showAxiosError({
          error,
          defaultMessage: "Failed to update supplier",
          showNotification: true,
          notificationTitle: "Error",
        })
      },
    },
  })
